export { default as DlpFiltersConfig } from './DlpFiltersConfig';
